<template>
  <app-modal
    v-model="isDialogOpened"
    size="xs"
    :ok-text="$t('common.confirm')"
    :ok-loading="isPending"
    :cancel-loading="isPending"
    @ok="onConfirm"
    @cancel="onCancel"
  >
    <template #title>{{ $t('project.signing-checklist.dialogs.PrepareSignatureDeleteInitialsTagDialog.title') }}</template>
    <template #body>
      <p class="mb-4 text--small">{{ $t('project.signing-checklist.dialogs.PrepareSignatureDeleteInitialsTagDialog.body') }}</p>
      <v-checkbox
        v-model="deleteAllTags"
        class="mt-0 pt-0 text--secondary align-top"
        :label="$t('project.signing-checklist.dialogs.PrepareSignatureDeleteInitialsTagDialog.deleteAllTagsLabel')"
        hide-details
      />
    </template>
  </app-modal>
</template>

<script>
import { defineComponent } from 'vue'

import { dialogMixin } from '@/mixins/dialogMixin'

export default defineComponent({
  name: 'PrepareSignatureDeleteInitialsTagDialog',
  mixins: [dialogMixin],
  data () {
    return {
      deleteAllTags: false,
    }
  },
  props: {
    isPending: {
      type: Boolean,
    },
  },
  methods: {
    onCancel () {
      this.closeDialog()
    },
    onConfirm () {
      if (this.deleteAllTags) {
        this.$emit('delete-all-tags')
      } else {
        this.$emit('delete-tag')
      }

      this.closeDialog()
    },
  },
})
</script>

<style scoped>
.v-dialog > .v-card > .v-card__subtitle {
  padding: 0;
  margin-top: 0;
}
</style>
